/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Header } from '../styles';
import { TableSpinner } from '../../shared';
const EmptyCard = ({ isLoading, }) => {
    return (React.createElement("li", null,
        React.createElement(Header, null),
        isLoading ? React.createElement(TableSpinner, null) : null));
};
export { EmptyCard };
//# sourceMappingURL=EmptyCard.js.map